import OtpRecordsPage from "../../otps/OtpRecordsPage";

export default function SsdiOTPs() {
  return (
    <OtpRecordsPage
      apiPath="/ssdi/otps"
      fallbackNote="OTP codes are shown for Super Admin."
    />
  );
}
